import { useEffect } from 'react';

import { useSolarPackages } from './services';
import { useOfferProductState } from './useOfferProductState';

export const useSelectSolarPackage = () => {
  const {
    selectBattery,
    selectSolarPanel,
    selectInverter,
    setSelectedDiscount,
    setSelectedDiscountWithoutInstallation,
    selectedSolarPanel,
    selectedInverter,
    selectedBattery,
    selectedDiscount,
    selectedDiscountWithoutInstallation,
  } = useOfferProductState();

  const { packages } = useSolarPackages();

  useEffect(
    function deselectedDiscountOnProductChange() {
      const packagesWithSameDiscount = packages.filter(
        solarPackage =>
          solarPackage.discount === selectedDiscount &&
          solarPackage.discountWithoutInstallation === selectedDiscountWithoutInstallation
      );

      packagesWithSameDiscount.forEach(packageWithSameDiscount => {
        const { solarPanel, inverter, batteries, defaultBatteryID } = packageWithSameDiscount;

        const battery = batteries?.find(({ id }) => id === defaultBatteryID);

        const isSolarPanelDifferent = solarPanel !== selectedSolarPanel;
        const isInverterDifferent = inverter !== selectedInverter;
        const isBatteryDifferent = battery !== selectedBattery;

        if (isSolarPanelDifferent || isInverterDifferent || isBatteryDifferent) {
          setSelectedDiscount(undefined);
          setSelectedDiscountWithoutInstallation(undefined);
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedSolarPanel, selectedInverter, selectedBattery, packages]
  );

  const selectSolarPackage = (selectedID: number) => {
    const selectedPackage = packages.find(({ packageID }) => packageID === selectedID);

    const { solarPanel, inverter, batteries, defaultBatteryID, discount, discountWithoutInstallation } =
      selectedPackage ?? {};

    const battery = batteries?.find(({ id }) => id === defaultBatteryID);

    if (solarPanel && inverter) {
      selectSolarPanel(solarPanel);
      selectInverter(inverter);

      setSelectedDiscount(discount);
      setSelectedDiscountWithoutInstallation(discountWithoutInstallation);

      if (battery) {
        selectBattery(battery);
      } else {
        selectBattery();
      }
    }
  };

  return { selectSolarPackage };
};
